/**
 * Catálogo de apresentações internas (sócios / master).
 * Conteúdo HTML fica em ./content/*.html.js (bundle) — NÃO em public/
 * (senão fica acessível sem login).
 */
export const PRESENTATIONS = [
  {
    id: "2026-08-14-chatwoot-funil-compras",
    title: "Funil de compras no Chatwoot",
    description:
      "Deck SCQA + dossiê: o Chatwoot não tem funil nativo. Modelo etapa_funil (contato) + label funil:* (conversa) + segmentos, com plano em 3 fases, benchmark e fontes.",
    date: "2026-08-14",
    contentModule: "2026-08-14-chatwoot-funil-compras",
  },
  {
    id: "2026-08-08-chatwoot-migracao-loja",
    title: "Migração Chatwoot — Loja",
    description:
      "Status pós-apply: wa_origin + outbound no homelab. Falta QR Leilão, E2E físico, números reais e cutover humano (Dia 0/1).",
    date: "2026-08-08",
    contentModule: "2026-08-08-chatwoot-migracao-loja",
  },
  {
    id: "2026-08-06-sistema-decisoes-dados",
    title: "Sistema de Decisões — Dados (CDO)",
    description:
      "Deck SCQA + dossiê CDO: SLA lab vs CX, Cockpit Atendimento, CVR-bot e path receita (bot/humano/self-serve). RPV, dicionário e ondas 12 meses.",
    date: "2026-08-06",
    contentModule: "2026-08-06-sistema-decisoes-dados",
  },
  {
    id: "2026-07-30-plano-conversao-crm-12m",
    title: "Plano 12 meses — Conversão + CRM",
    description:
      "Deck SCQA + dossiê (pilares Converter / Atender-Vender / Recorrer). Identidade Manafix. Canal lojista/lote, CRM e cenários de investimento.",
    date: "2026-07-30",
    contentModule: "2026-07-30-plano-conversao-crm-12m",
  },
];

export function getPresentationById(id) {
  return PRESENTATIONS.find((p) => p.id === id) || null;
}

/** Carrega HTML embutido no bundle (só após rota autenticada importar o viewer). */
export async function loadPresentationHtml(contentModule) {
  switch (contentModule) {
    case "2026-08-14-chatwoot-funil-compras": {
      const mod = await import(
        /* webpackChunkName: "presentation-chatwoot-funil-compras" */
        "./content/2026-08-14-chatwoot-funil-compras.html.js"
      );
      return mod.default;
    }
    case "2026-08-08-chatwoot-migracao-loja": {
      const mod = await import(
        /* webpackChunkName: "presentation-chatwoot-migracao-loja" */
        "./content/2026-08-08-chatwoot-migracao-loja.html.js"
      );
      return mod.default;
    }
    case "2026-08-06-sistema-decisoes-dados": {
      const mod = await import(
        /* webpackChunkName: "presentation-sistema-decisoes-dados" */
        "./content/2026-08-06-sistema-decisoes-dados.html.js"
      );
      return mod.default;
    }
    case "2026-07-30-plano-conversao-crm-12m": {
      const mod = await import(
        /* webpackChunkName: "presentation-plano-conversao-crm-12m" */
        "./content/2026-07-30-plano-conversao-crm-12m.html.js"
      );
      return mod.default;
    }
    default:
      return null;
  }
}
